// extracted by mini-css-extract-plugin
export default {"zoomModal":"G4-z"};